import * as Sentry from '@sentry/react';

type DiagnosticLevel = 'debug' | 'info' | 'warning' | 'error';

type SafeDiagnosticData = Record<string, boolean | number | string | null | undefined>;

const REDACTED_FIELDS = new Set([
  'token',
  'customToken',
  'signature',
  'challenge',
  'privateKey',
  'publicKey',
]);

function sanitize(data: SafeDiagnosticData): SafeDiagnosticData {
  return Object.fromEntries(
    Object.entries(data).filter(([key]) => !REDACTED_FIELDS.has(key))
  ) as SafeDiagnosticData;
}

export function recordAuthV3Diagnostic(
  message: string,
  data: SafeDiagnosticData = {},
  level: DiagnosticLevel = 'info'
): void {
  Sentry.addBreadcrumb({
    category: 'auth.v3',
    message,
    level,
    data: sanitize(data),
  });
}

export function reportAuthV3RecoveryFailure(
  message: string,
  data: SafeDiagnosticData = {}
): void {
  Sentry.captureMessage(message, {
    level: 'warning',
    tags: { subsystem: 'auth-v3' },
    extra: sanitize(data),
  });
}
